import { defineStore } from 'pinia'
import { appConfig} from '@/utils/config'

export const useI18nStore = defineStore('i18n', {
  state: () => ({
    locale: localStorage.getItem('locale') || appConfig.locals,
    languageList : appConfig.languageList
  }),
  actions: {
    // 切换语言
    toggleLanguage(val) {
      const newLang = val
      this.locale = newLang
      localStorage.setItem('locale', newLang)
    }
  }
})
